﻿if (String.format === undefined) {
	var _formatRE = /(\{[^}{]+\})/g;
	String.format = function String$format(format/*, value1, value2, valueN*/) {
		var a = arguments;
		return format.replace(_formatRE, function (str, m) {
			var v = a[parseInt(m.substring(1)) + 1];
			return v != null ? v.toString() : "";
		});
	};
}